// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__kgik9","Logo":"Toolbar_Logo__ihB_i","DesktopOnly":"Toolbar_DesktopOnly__18DV6"};